export const UPDATE_EMPLOYEE_REQUEST = 'UPDATE_EMPLOYEE_REQUEST';

export const updateEmployeeRequest = ( id, updateData ) => ({
    type: UPDATE_EMPLOYEE_REQUEST,
    payload: {
        id,
        updateData
    }
});
